// @flow

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Loading from '../Icons/loading.gif'
import Paginate from '../Buttons/Paginate'
import './SmsUsersTable.css'
import InfoIcon from '../../Shared/Icons/icon-info-grey.svg'
import { formatPhoneNumber } from '../stringUtils'
import GenerateReportButton from '../Buttons/GenerateReportButton'

type Props = {
  changeOffset: Function,
  data: Array,
  fields: Array,
  page: number,
  totalUsers: number,
  title: string,
  tooltipText: string,
  reportStatus: string,
  generateReport: Function
}

const HeaderTitle = styled.span`
  float: left;
  font-size: 20px;
  padding: 17px 15px 25px 23px;
`

class SmsUsersTable extends Component<Props> {
  generateReportClick = () => {

  }

  /** render function */
  render () {
    const fields = this.props.fields
    const notAvailableFields = ['name', 'email']
    const headers = fields.map((field, index) =>
      <th key={index}>
        <span>{field.title}</span>
      </th>)
    const users = this.props.data.map((user, i) => {
      if (user.name === 'Loading') {
        return (<tr key={Math.random()}><td><img src={Loading} alt='Loading' /></td></tr>)
      } else {
        return (
          <tr key={i}>{fields.map((field) => {
            if (field.ref === 'regCode') {
              return (
                <td key={field.ref}>
                  <Link to={{ pathname: '/sms-history', search: '?id=' + user._id }}>{user[field.ref] || '--'} </Link>
                </td>
              )
            }
            if (field.ref === 'phoneNumber') {
              return (
                <td key={field.ref}>{user.phoneNumber ? formatPhoneNumber(user.phoneNumber) : '--'} </td>
              )
            }
            if (notAvailableFields.indexOf(field.ref) !== -1) {
              return (
                <td key={field.ref}>{user[field.ref] || 'Not Available'} </td>
              )
            }
            return (
              <td key={field.ref}>{user[field.ref] || '--'} </td>
            )
          })}</tr>
        )
      }
    }
    )
    return (
      <div>
        <div className='table-wrapper'>
          <div className='SmsUsersTable'>
            <div className='flex align-center'>
              <HeaderTitle>{this.props.title}</HeaderTitle>
              <div className='tooltip'>
                <span><img className='icon-md' src={InfoIcon} alt={InfoIcon} /></span>
                <span className='tooltipText'>{this.props.tooltipText}</span>
              </div>
              <div style={{ marginLeft: 'auto', padding: '17px' }}>
                <GenerateReportButton status={this.props.reportStatus} generateReportClicked={this.props.generateReport} />
              </div>
            </div>
            <table>
              <thead><tr>{headers}</tr></thead>
              <tbody>
                {users}
              </tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalUsers} />
      </div>
    )
  }
}

export default SmsUsersTable
